/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getBadgeSubmission = /* GraphQL */ `
  query GetBadgeSubmission($id: ID!) {
    getBadgeSubmission(id: $id) {
      id
      email
      siteCode
      formType
      tokenNumber
      queuePosition
      estimatedTime
      timeSlot
      slotPosition
      photoTaken
      status
      updatedBy
      submissionDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBadgeSubmissions = /* GraphQL */ `
  query ListBadgeSubmissions(
    $filter: ModelBadgeSubmissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBadgeSubmissions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        siteCode
        formType
        tokenNumber
        queuePosition
        estimatedTime
        timeSlot
        slotPosition
        photoTaken
        status
        updatedBy
        submissionDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
